import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import LandingPage from '../components/LandingPage';
import CookieConsent from '../components/CookieConsent';
import '../../assets/stylesheets/application.tailwind.css';
import '../i18n/config';

function App() {
  return (
    <StrictMode>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
        <div className="mx-auto">
          <LandingPage />
          <CookieConsent />
        </div>
      </div>
    </StrictMode>
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root');
  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  }
}); 